<template>
  <div class="authenticate">
    <h1 class="authentication__title">Boodschapp</h1>
    <!--<h2>Leuk je weer te zien!</h2>-->
    <credentials
      :emailAddress="emailAddress"
      :password="password"
      @emailaddressEntered="emailaddressEntered"
      @passwordEntered="passwordEntered"
      @confirmed="confirmedLogin"
    />

  </div>
</template>

<script>
  import firebase from 'firebase'
  import {mapActions} from 'vuex'
  import { Credentials } from '@/components/organisms'

  export default {
    name: 'login',
    data () {
      return {
        e1: true,
        emailAddress: 'erinblauw@icloud.com',
        password: 'Test123!'
      }
    },
    components: {
      Credentials
    },
    methods: {
      ...mapActions({
        loginUser: 'loginUser'
      }),
      emailaddressEntered (emailAddress) {
        this.emailAddress = emailAddress
      },
      passwordEntered (password) {
        this.password = password
      },
      confirmedLogin () {
        // UsersApi.registerUser(this.emailAddress, this.password)
        firebase.auth().signInWithEmailAndPassword(this.emailAddress, this.password)
          .then(response => {
            console.log(response.providerData)
            this.loginUser(response.providerData)
          })
          .catch(function (error) {
            // Handle Errors here.
            let errorCode = error.code
            let errorMessage = error.message
            console.log(errorCode, errorMessage)
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Login.vue?6491b50e